<template>
  <div class="user-guide-body">
    <h2>TimeOnline User's Guides</h2>
    <ul class="user-guide-list">
      <li>
        <h3>
          <a href="javascript:void" @click.prevent="download('TimeOnline')">About TimeOnline</a>
        </h3>
      </li>
      <li v-if="isApprover">
        <h3>
          <a href="javascript:void" @click.prevent="download('Approver')">Approver User Guide</a>
        </h3>
      </li>
      <li v-if="isContractor">
        <h3>
          <a href="javascript:void" @click.prevent="download('Contractor')">Contractor UG</a>
        </h3>
      </li>
    </ul>
  </div>
</template>
<script>
import { helpService } from '../help/help.service';
export default {
  data() {
    return {};
  },
  computed: {
    isContractor() {
      return (
        this.currentUser &&
        (this.currentUser.roles.map(r => r.role_name).some(role => role === 'Contractor') ||
          this.isTesEmployee)
      );
    },
    isApprover() {
      return (
        (this.currentUser &&
          this.currentUser.roles.map(r => r.role_name).some(role => role === 'Client Contact')) ||
        this.isTesEmployee
      );
    },
    isSystemAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'System Admin')
      );
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isTesEmployee() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'TES Employee')
      );
    }
  },
  methods: {
    download(userGuide) {
      helpService.downloadUserGuide(userGuide);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors';
.user-guide-body {
  padding: 60px;
  background-color: $white;
}
</style>
